import "fontsource-source-sans-pro"

import { createRoot } from "react-dom/client"
import "./index.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import "./i18n"

const container = document.getElementById("root")
const root = createRoot(container)
root.render(<App />)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
